import React from 'react';
import ContainerTemplate from '../../widgets/template/Container';
import ReportesView from './ReportesView';
import * as ROUTES from '../../router/Routes';

const ReportesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.reportes} routes={[]}>
      <ReportesView />
    </ContainerTemplate>
  );
};

export default ReportesModule;
